const canvas = document.getElementById("snowcristmas");
const ctx = canvas.getContext("2d");

function resize() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}
resize();
window.onresize = resize;

// ---- OPTIONS ----
let WIND = 0;     // horizontal drift (-1 to 1)
let SPEED = 0.6;    // fall speed multiplier
const COUNT = 50;  // number of flakes
// ------------------

const flakes = [];
for (let i = 0; i < COUNT; i++) {
  flakes.push({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    r: 1 + Math.random() * 3,
    vy: 0.5 + Math.random(),  // base gravity
    vx: (Math.random() - 0.5) * 0.3, // natural sideways drift
  });
}

function draw() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  for (const f of flakes) {
    // update
    f.x += f.vx + WIND;
    f.y += f.vy * SPEED;

    // recycle flakes
    if (f.y > canvas.height) f.y = -10;
    if (f.x > canvas.width) f.x = 0;
    if (f.x < 0) f.x = canvas.width;

    // draw
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
    ctx.fill();
  }

  requestAnimationFrame(draw);
}

draw();
